import { useEffect } from "react";
import { treeify } from "../../../../common/Helpers";
import { useTranslation } from "react-i18next";

const useOfSetContractListConfigData = (selectedId, inputParam_ContractList, inputParam_ContractModalitysList, setContractList, setContractModalitysList, setterFired, setSetterFired) => {    
    const { t } = useTranslation();
    
    useEffect(()=> {
        const setData = async () => {
            try {
                const contractList = inputParam_ContractList.map(x => { return { id: x.id, key: x.id, text: `${x.contractCode}: ${x.name}`, amount: x.amount  } });
                contractList.unshift({id: 0, key: 0, text: t('data-lang-lbl-select'), amount: null});
                const aux_contractList = treeify(contractList, 'key', null, 'children', null, 'text')

                if (aux_contractList !== null) {
                    for (const element of aux_contractList) {
                        if (element.id === selectedId) {
                            element.checked = true;
                        }
                    }
                }
                else {
                    for (const element of aux_contractList) {
                        element.checked = false;
                    }
                }

                const contractModalitysList = inputParam_ContractModalitysList.map(x => { return { key: x.key, text: `${x.name}`  } });
                contractModalitysList.unshift({key: 0, text: t('data-lang-lbl-select')});
            
                setContractList(aux_contractList);
                setContractModalitysList(contractModalitysList);
                setSetterFired(true);
            }
            catch (error) {
            }
        }
        
        if (setterFired === false) {
            setData()
        }
    }, [inputParam_ContractList, inputParam_ContractModalitysList, setContractList, setContractModalitysList, setterFired, setSetterFired]);
}

export {
    useOfSetContractListConfigData
}